
export const emailConstraints = {
	email: {
		email: {
			message: 'Please supply a valid email'
		},
		presence:{
			message: 'Please supply a valid email'
		}
	}
}

const clientIdPattern = /([\d]){8}-([\d])/
export const clientIdConstraints = {
	clientId: {
		format: {
			pattern: clientIdPattern,
			message: 'Client number should be in the format 12345678-1'
		},
		presence:{
			message: 'Please supply a client number'
		}
	}
}

export const passwordConstraints = {
	password:{
		presence:{
			message:'is required'
		}
	}
}

export const usernameConstraints = {
	username:{
		presence:{
			message: '^Please supply a client number or email'
		},
		username:{
			message: '^Please supply a valid client number or email'
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/form/fieldConstraints.js